export default function saveReviewPageType(reviewPageType: any) {
  localStorage.setItem("review_page_type", reviewPageType);
}
